import { render } from "./Footer.vue?vue&type=template&id=a7efd6b6"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"
script.render = render

export default script